// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1akLX","rootCenter":"LoadMoreObserver_rootCenter__30Rgo","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__18HKZ"};